import { cookiesConsent } from "./helpers/cookies_consent";

// ! Cookies consent
const cookiesPopup = document.querySelector("#cookies");
const allowBtnCookies = document.querySelector(".cookies_consent_btn");
const cookiesName = "joriside";

if (cookiesPopup && allowBtnCookies && cookiesName) {
    cookiesConsent(cookiesPopup, allowBtnCookies, cookiesName);
}

const app = document.querySelector("#app");
const citySelect = document.querySelector("#city");

// Toggle Dark/Light Theme
// const changeThemeBtn = document.querySelector(".q10__btn__change_theme");
// if (changeThemeBtn) {
//     changeThemeBtn.addEventListener("click", (e) => {
//         app.classList.toggle("dark-theme");
//     });
// }

// Set Content Display
const setContentDisplay = () => {
    const header = document.querySelector(".q10__header");
    const footer = document.querySelector(".q10__footer");

    if (header && footer) {
        let headerH = header.offsetHeight + 1;
        let footerH = footer.offsetHeight + 1;
        app.style.setProperty("--header_height", headerH + "px");
        app.style.setProperty("--footer_height", footerH + "px");
    }
};

MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
let observer = new MutationObserver((mutations, observer) => {
    // fired when a mutation occurs
    mutations.forEach((mutation) => {
        let oldValue = mutation.oldValue;
        let newValue = mutation.target.textContent;
        if (oldValue !== newValue) {
            setContentDisplay();
        }
    });
});
// define what element should be observed by the observer
// and what types of mutations trigger the callback
observer.observe(document, {
    characterDataOldValue: true,
    subtree: true,
    childList: true,
    characterData: true,
});
window.addEventListener("DOMContentLoaded", setContentDisplay);
window.addEventListener("resize", setContentDisplay);


function scrollTop() {
    const scrollTop = document.querySelector(".scrolltop");
    if (this.scrollY >= 560) scrollTop.classList.add("show-scroll");
    else scrollTop.classList.remove("show-scroll");
}
window.addEventListener("scroll", scrollTop);

window.openMenu= function(){
    var targetMenu = document.querySelector(".dropdown-content")
    var selectMenu = document.querySelector("#selected")
    if (targetMenu.style.display === "block") {
    targetMenu.style.display = "none";
    selectMenu.style = "box-shadow: 0;"
    } else {
    targetMenu.style.display = "block";
    
    selectMenu.style = "box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;"
    }
}

// // Sort cities by value/text
// function sortOptionsByText(a, b) {
//     if (a.value.length == 0 || (b.value.length > 0 && a.text <= b.text))
//         return -1;
//     return 1;
// }

// function sortOptionsByValue(a, b) {
//     if (a.value <= b.value) return -1;
//     return 1;
// }

// function clearChildren(elem) {
//     if (elem) {
//         while (elem.firstChild) {
//             elem.removeChild(elem.firstChild);
//         }
//     }
// }

// function sortSelectElem(sel, byText) {
//     const val = sel.value;
//     const tmp = [...sel.options];
//     tmp.sort(byText ? sortOptionsByText : sortOptionsByValue);
//     clearChildren(sel);
//     sel.append(...tmp);
//     sel.value = val;
// }

// window.addEventListener("DOMContentLoaded", sortSelectElem(citySelect, true));
